<template>
    <div class="accordion accordion-flush" :id="`AD${uuid}HeadingParent`">
        <div class="accordion-item shadow">
            <h2 class="accordion-header" :id="`AD${uuid}Heading`">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    :data-bs-target="`#AD${uuid}Collapse`" aria-expanded="false" :aria-controls="`AD${uuid}Collapse`">
                    {{ title }}
                </button>
            </h2>
            <div :id="`AD${uuid}Collapse`" class="accordion-collapse loading-viewport collapse"
                :aria-labelledby="`AD${uuid}Heading`" :data-bs-parent="`#AD${uuid}HeadingParent`">
                <CommonSpinner v-if="isLoading" :box="true" />
                <div class="accordion-body">
                    <slot name="body"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        isLoading: {
            type: Boolean,
            default: false
        },
        uuid: {
            type: String,
            default: () => String(Math.floor(100000 + Math.random() * 900000))
        },
        title: {
            type: String,
            default: "Accordion Filter"
        }
    }
}
</script>

<style>
.accordion .accordion-body {
    color: var(--bs-gray-800) !important;
}
</style>